import React, { useState } from 'react';
import { toast } from 'sonner';
import { API_URL, getHeaders } from './shared';

export function InlineAccessRequest({ anonymousId }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [urgency, setUrgency] = useState('normal');
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!reason.trim()) { toast.error('Reason required'); return; }
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/portfolio-access`, {
        method: 'POST', headers: getHeaders(),
        body: JSON.stringify({ target_user_id: anonymousId, reason, urgency }),
      });
      if (!res.ok) { const e = await res.json(); throw new Error(e.detail || 'Failed'); }
      toast.success('Access request submitted');
      setOpen(false); setReason('');
    } catch (e) { toast.error(e.message); }
    finally { setSubmitting(false); }
  };

  if (!open) return (
    <button data-testid="request-access-btn" onClick={() => setOpen(true)} className="text-xs text-blue-400 hover:text-blue-300 font-medium transition">Request Full Access</button>
  );

  return (
    <div className="bg-gray-700/50 border border-gray-600 rounded-lg p-3 space-y-2">
      <textarea data-testid="access-request-reason" value={reason} onChange={e => setReason(e.target.value)}
        placeholder="Reason for access..." className="w-full text-sm bg-gray-800 border border-gray-600 rounded-lg p-2 text-white placeholder-gray-500 resize-none focus:border-green-500" rows={2} />
      <div className="flex items-center gap-2">
        <select data-testid="access-request-urgency" value={urgency} onChange={e => setUrgency(e.target.value)}
          className="text-xs bg-gray-800 border border-gray-600 rounded-lg px-2 py-1.5 text-white">
          <option value="normal">Normal</option><option value="high">High</option><option value="critical">Critical</option>
        </select>
        <button data-testid="submit-access-request" onClick={submit} disabled={submitting}
          className="text-xs bg-green-600 text-white px-3 py-1.5 rounded-lg hover:bg-green-700 disabled:opacity-50 transition font-medium">
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
        <button onClick={() => setOpen(false)} className="text-xs text-gray-400 hover:text-gray-300">Cancel</button>
      </div>
    </div>
  );
}
